import * as React from "react";

import "./file-upload.scss";

import {cs}      from "@Common/react/chain-services";
import {Static2} from "@Common/react/static-2";

import {ellipsisMiddle} from "../../../../heavy/common/design2/data-table/mobile/ellipsis-middle";
import {cx} from "emotion";

export const FileUpload = ({fileName, mobile, onRemove, onChange}) => cs(
    ["ref", (_, next) => Static2({next})],
    ({ref}) => (
        <div className={cx("file-upload file-upload-7tr", {mobile})}>
            <div {...{
                className: "title",
                "xd-qa-type": "label",
                "xd-qa-name": "Upload Mask Image",
            }}>
                Upload Mask Image
            </div>
            <div className="browse">
                <button {...{
                    disabled: !!fileName,
                    onClick: () => ref.get().click(),

                    "xd-qa-type": "button",
                    "xd-qa-name": "BROWSE",
                }}>
                    BROWSE
                </button>

                <input {...{
                    type: "file",
                    onChange: (e) => {
                        onChange(e.target.files[0]);
                        e.target.value = null;
                    },
                    style: {
                        display: "none",
                    },
                    ref: ref.set,
                }}/>
            </div>
            <div className="message">
                Images must be in JPEG (.jpg, .jpeg) or PNG format. Less than 10MB in file size.
            </div>

            {fileName && (
                <div className="uploaded-file">
                    <div className="file-name" title={fileName}>
                        {ellipsisMiddle(fileName, 13)}
                    </div>
                    <div className="remove">
                        <a {...{
                            onClick: onRemove,
                        }}>Remove</a>
                    </div>
                </div>
            )}
        </div>
    ),
);
